import {SET_ADDITIONAL_SELECTION_DATA} from '../actions';
import {
  SelectedAdditionalCheckBoxModel,
  SelectedAdditionalCheckBoxModelActions
} from '../mappers/SelectedAdditionalCheckBoxTypes';
import produce, {Draft} from 'immer';
export const initialSelectedCheckBoxState: SelectedAdditionalCheckBoxModel = {
  selectionData: []
};

export const selectedAdditionalCheckBoxReducer = produce(
  (
    state: Draft<SelectedAdditionalCheckBoxModel>,
    action: SelectedAdditionalCheckBoxModelActions
  ) => {
    if (action.type === SET_ADDITIONAL_SELECTION_DATA) {
      const listData: any = action.payload?.data;
      state.selectionData = listData;
    }
  },
  initialSelectedCheckBoxState
);
